





















































































































import {ComponentBase, Overlay, SvgIcon} from "@/modules/budget/staffing-table/components";
import {Component, Model, Prop} from "vue-property-decorator";
import ConfirmModal from "@/modules/budget/staffing-table/components/ConfirmModal.vue";
import {SingleBudgetProgramField} from "@/modules/budget/staffing-table/budget-programs";
import {SingleBudgetVariantField} from "@/modules/budget/staffing-table/budget-variants";
import {SingleOrgField} from "@/modules/budget/staffing-table/organizations";
import {SingleVersionField} from "@/modules/budget/staffing-table/versions";
import CurYearField from "@/modules/budget/staffing-table/components/CurYearField.vue";
import {BudgetVariants, Comp, Dict, Report, Report2} from "@/modules/budget/staffing-table/types";
import * as common from "@/modules/budget/staffing-table/common";
import {staffTabAccess} from "@/modules/budget/staffing-table/common";
import i18n from "@/services/i18n";
import axios from "axios";
import {generateExpression} from "@/modules/budget/staffing-table/reports/templates/expressionHelper";

const events = {
    formReportSaved: 'form-report-saved',
    formReportUpdateCondition: 'form-report-update-condition'

};
const modelChangeEvent = 'change'

const translates = {
    tools: {
        buttons: {
            get downloadReport(): string {
                return i18n.choose(
                    'Скачать',
                    'Жүктеп алу',
                    'Download',
                );
            },
            get generateReport(): string {
                return i18n.choose(
                    'Сформировать',
                    'Пішін',
                    'Generate',
                );
            }
        }
    },
    errors: {
        get cannotLoadBudgetSubprograms(): string {
            return i18n.choose(
                'Cannot load budget subprograms',
                'Не удалось загрузить бюджетные подпрограммы (каз)',
                'Не удалось загрузить бюджетные подпрограммы',
            );
        },
    },
    fields: {
        budgetSubprogram: {
            get title(): string {
                return i18n.choose(
                    'Бюджетная подпрограмма',
                    'Бюджетная подпрограмма (каз)',
                    'Budget subprogram',
                );
            },
            get emptyValue(): string {
                return i18n.choose(
                    '[ Нет значения ]',
                    '[ Нет значения ] (каз)',
                    '[ No value ]',
                );
            },
        },
    },
};
@Component({
    components: {
        ConfirmModal,
        Overlay,
        SingleBudgetProgramField,
        SingleBudgetVariantField,
        SingleOrgField,
        SingleVersionField,
        SvgIcon,
        CurYearField
    },
})

export default class GenerateReport extends ComponentBase {
    constructor() {
        super('modules.budget.staffing_table.reports.*XlsxGenerationPane*');
    }

    @Model(
        modelChangeEvent,
        {
            type: Boolean,
            required: true,
            default: false,
        },
    )
    readonly formReportLoading!: boolean

    get formReportLoadingSync(): boolean {
        return this.formReportLoading
    }

    set formReportLoadingSync(value: boolean) {
        this.$emit(modelChangeEvent, value)
    }

    @Prop({ type: String, default: null })
    public readonly regionCode!: string | null;

    @Prop({ type: Object, default: null })
    public readonly budgetVariant!: BudgetVariants  | null;

    @Prop({ type: Number, default: null })
    public readonly staffTabVersionId!: number | null;

    @Prop({ type: Number, required: true })
    public readonly reportYear!: number;

    @Prop({ type: Object, default: null })
    public readonly budgetProgram!: Dict.EbkFunc | null;
    // endregion

    protected created() {
        super.created();

        // region Данные
        this.$watch('budgetProgram', (budgetProgram: Dict.EbkFunc | null, oldBudgetProgram: Dict.EbkFunc | null) => {
            const code = budgetProgram?.prg ?? null;
            const oldCode = oldBudgetProgram?.prg ?? null;
            if (code !== oldCode) {
                this.resetBudgetSubprograms()
            }
            this.loadBudgetSubprograms()
        });

        this.$watch('reportYear', () => {
            this.reloadSpecificities();
        });

        this.$watch('specificity', (specificity: Dict.EbkEk | null) => {
            common.store.specificity = specificity;

            const specificityCode = specificity?.spf ?? null;
            if (specificityCode === null) {
                this.form = null;
            } else {
                const forms = common.specificityToReportFormKeyMap.get(specificityCode);
                // noinspection JSIncompatibleTypesComparison
                if (forms === undefined) {
                    this.form = null;
                } else {
                    const index = forms.findIndex((testedForm) => (testedForm === this.form));
                    if (index < 0) {
                        this.form = null;
                    }
                }
            }
            if ((this.templateKeyIsSpecific)) {
                this.upDateConditionExp();
            }
        });

        this.$watch('form', (form: Report.FormKey | null) => {
            common.store.form = form;
            console.log(this.templateKeyIsForm)
            if (this.templateKeyIsForm) {
                this.upDateConditionExp();
            }
        });

        // endregion
    }

    protected mounted() {
        super.mounted();
         this.reloadSpecificities();

        if (this.budgetProgram !== null) {
             this.loadBudgetSubprograms();
        }
    }

    // region Активный шаблон запроса
    templateKey = common.store.templateKey

    // region Утилиты
    public translates = translates;

    // Доступ к редактированию данных
    get isEditable(): boolean {
        return staffTabAccess.isEditable;
    }

    public upDateConditionExp() {
        const conditionExp = generateExpression(this.templateKey)
        if (conditionExp != null) {
            this.$emit(events.formReportUpdateCondition, conditionExp, this.templateKey);
        }
    }

    get canDownloadResponse(): boolean {
        return (this.budgetVariant?.variantUuid !== null) && (this.budgetProgram !== null) && (this.form !== null) && (this.staffTabVersionId !== null)
    }

    private get isActualVariant(): boolean {
        return (this.budgetVariant !== null) && (this.budgetVariant?.attribute === true) && (!this.budgetVariant.status);
    }

    public get generationAndSavingForbidden(): boolean {
        return this.budgetVariantForbiddenForGenerationAndSending || this.detailedReport || this.debugging || (!this.isActualVariant);
    }
    // endregion

    public get budgetVariantForbiddenForGenerationAndSending(): boolean {
        const variantUuid = this.budgetVariant?.variantUuid;
        if (variantUuid === null) {
            return false;
        }

        const budgetVariantYear = this.budgetVariant?.year;
        if (budgetVariantYear === null) {
            return false;
        }

        const reportYear = this.reportYear;
        return (budgetVariantYear !== reportYear);
    }

    get templateKeyIsForm(): boolean {
        return  this.templateKey === 'form-reports'
    }
    get templateKeyIsSpecific(): boolean {
        return  this.templateKey === 'specificity-reports'
    }

    // region Расширенный отчет, отладка
    public detailedReport = false;

    public debugging = false;
    // endregion

    private generateReportUsingSettings(
        action: (
            regionCode: string,
            budgetVariantUUID: string,
            budgetProgramCode: number,
            budgetSubprogramCode: number | null,
            form: Report.FormKey,
            versionId: number,
            reportYear: number,
            debugging: boolean,
            reportType: ('COMMON' | 'DETAILED'),
        ) => unknown,
    ) {
        const regionCode = this.regionCode ?? null;
        if (typeof regionCode !== 'string') {
            console.error('Cannot define region');
            return;
        }

        const budgetVariantUUID = this.budgetVariant?.variantUuid ?? null;
        if (typeof budgetVariantUUID !== 'string') {
            console.error('Cannot define budget variant UUID');
            return;
        }

        const budgetProgramCode = this.budgetProgram?.prg ?? null;
        if (typeof budgetProgramCode !== 'number') {
            console.error('Cannot define budget program code');
            return;
        }

        const form = this.form;
        if (form === null) {
            console.error('Report form is NULL');
            return;
        }

        const versionId = this.staffTabVersionId ?? null;
        if (typeof versionId !== 'number') {
            console.error('Version ID is null');
            return;
        }

        const budgetSubprogramCode = this.budgetSubprogram?.ppr ?? null;

        const reportYear = this.reportYear;
        const debugging = this.debugging;

        let reportType: ('COMMON' | 'DETAILED');
        if (this.detailedReport) {
            reportType = 'DETAILED';
        } else {
            reportType = 'COMMON';
        }

        action(regionCode, budgetVariantUUID, budgetProgramCode, budgetSubprogramCode, form, versionId, reportYear, debugging, reportType);
    }

    // region Бюджетная подпрограмма
    public budgetSubprogramLoading = false;
    public budgetSubprograms: Array<Dict.EbkFunc> = [];
    public budgetSubprogram: Dict.EbkFunc | null = common.store.budgetSubprogram;

    private resetBudgetSubprograms() {
        this.budgetSubprograms = []
        this.budgetSubprogram = null;
    }

    public loadBudgetSubprograms() {
        if (this.budgetSubprogramLoading) {
            console.error('Cannot load budget subprograms - another loading is running');
            return;
        }

        const budgetProgram = this.budgetProgram;
        if (budgetProgram === null) {
            console.error('Cannot load budget subprograms - budget program is NULL');
            return;
        }

        const year = this.reportYear;
        if (year === null) {
            console.error('Cannot load budget subprograms - year is NULL');
            return;
        }
        const funcGroupCode = budgetProgram.gr!!;
        const funcSubgroupCode = budgetProgram.pgr!!;
        const abpCode = budgetProgram.abp!!;
        const budgetProgramCode = budgetProgram.prg!!;
        const date = new Date(year, 0, 1, 0, 0, 0, 0).getTime();

        const url = this.prepareUrl(
            '/api/budget/staffing_table/report/budget-subprograms',
            [
                ['func-group-code', funcGroupCode],
                ['func-subgroup-code', funcSubgroupCode],
                ['abp-code', abpCode],
                ['budget-program-code', budgetProgramCode],
                ['date', date],
            ],
        );

        this.budgetSubprogramLoading = true;
        const oldBudgetSubprogram = this.budgetSubprogram;
        this.budgetSubprogram = null;
        this.budgetSubprograms = [];

        this.request<Array<Dict.EbkFunc>>(
            { url },
            (data) => {
                let newBudgetSubprogram: Dict.EbkFunc | null = null;
                if (oldBudgetSubprogram !== null) {
                    const index = data.findIndex((budgetSubprogram) => (budgetSubprogram.id === oldBudgetSubprogram.id));
                    if (index >= 0) {
                        newBudgetSubprogram = data[index];
                    }
                } else {
                    newBudgetSubprogram = data.find(ebk => ebk.ppr === 15) ?? null
                }
                this.budgetSubprograms = data;
                this.budgetSubprogram = newBudgetSubprogram;
            },
            () => (translates.errors.cannotLoadBudgetSubprograms),
            () => {
                this.budgetSubprogramLoading = false;
            },
        );
    }

    public getBudgetSubprogramTitle(item: Dict.EbkFunc): string {
        let code = (item.ppr!!).toString();
        while (code.length < 3) {
            code = '0' + code;
        }

        const name = i18n.choose(
            () => (item.nameRu ?? item.id!!.toString()),
            () => (item.nameKk ?? item.nameRu ?? item.id!!.toString()),
            () => (item.nameRu ?? item.id!!.toString()),
        )();

        return `${code} - ${name}`;
    }
    // endregion

    // region Специфика/форма
    public specificityToReportFormKeyMap = common.specificityToReportFormKeyMap;

    public specificitiesLoading = false;

    public specificities: Array<Dict.EbkEk> = [];

    public get specificityOptions(): Array<Comp.DropdownItemDef<Dict.EbkEk>> {
        const result: Array<Comp.DropdownItemDef<Dict.EbkEk>> = [];

        this.specificities.forEach((specificity) => {
            const code = ((): string => {
                let result = String(specificity.spf);
                while (result.length < 3) {
                    result = '0' + result;
                }
                return result;
            })();

            const name = this.localize(
                () => (specificity.nameRu || ''),
                () => (specificity.nameKk || ''),
                () => (specificity.nameRu || ''),
            );

            result.push({
                text: `${code} - ${name}`,
                value: specificity,
            });
        });

        return result;
    }

    public specificity: Dict.EbkEk | null = common.store.specificity;
    public async reloadSpecificities() {
        if (this.specificitiesLoading) {
            console.error('Cannot load specificities - another loading is running');
            return;
        }

        const codes = common.specificityCodes;
        const reportYear = this.reportYear;

        this.specificities = [];
        this.specificitiesLoading = true;

        const url = this.prepareUrl(
            '/api/budget/staffing_table/specificities',
            [
                ['codes', codes],
                ['year', reportYear],
            ],
        );

        try {
            const data = await axios.get<Array<Dict.EbkEk>>(url);
            this.specificities = data.data.sort((specificity1, specificity2): number => {
                const code1 = specificity1.spf ?? 0;
                const code2 = specificity2.spf ?? 0;
                return code1 - code2;
            });

            if (this.specificity !== null) {
                const id = this.specificity.id;
                const index = this.specificities.findIndex(
                    (loadedSpecificity) => loadedSpecificity.id === id
                );
                this.specificity = index >= 0 ? this.specificities[index] : null;
            }
        } catch (error) {
            this.toast(
                'danger',
                this.i18n.translate('cannot_load_specificities'),
                error.toString(),
            );
        } finally {
            this.specificitiesLoading = false;
        }
    }

    public form: Report.FormKey | null = common.store.form;
    public onFormChanged(form: Report.FormKey | null | undefined) {
        this.form = form ?? null;
    }

    public get formOptions(): Array<Comp.DropdownItemDef<Report.FormKey>> {
        const result: Array<Comp.DropdownItemDef<Report.FormKey>> = [];

        const specificity = this.specificity?.spf ?? null;
        if (specificity !== null) {
            const forms = this.specificityToReportFormKeyMap.get(specificity);
            // noinspection JSIncompatibleTypesComparison
            if (forms !== undefined) {
                forms.forEach((form) => {
                    let code = String(form);
                    if (code.toUpperCase().startsWith('F_')) {
                        code = code.substring(2);
                    }
                    code = code.replaceAll('_', '-');

                    result.push({
                        text: code,
                        value: form,
                    });
                });
            }
        }

        return result;
    }

    public generateAndDownloadReport() {
        this.generateReportUsingSettings((regionCode, budgetVariantUUID, budgetProgramCode, budgetSubprogramCode, form, versionId, reportYear, debugging, reportType) => {
            const url = this.prepareUrl(
                '/api/budget/staffing_table/report-v2/form-report.zip',
                [
                    ['region',            regionCode],
                    ['version',           versionId],
                    ['budget-variant',    budgetVariantUUID],
                    ['budget-program',    budgetProgramCode],
                    ['budget-subprogram', budgetSubprogramCode],
                    ['form',              form],
                    ['year',              reportYear],
                    ['debugging',         debugging],
                    ['report-type',       reportType],
                ],
            );
            this.openUrl(url);
        });
    }

    public generateAndSaveReport() {
        this.formReportLoadingSync = true
        this.generateReportUsingSettings((regionCode, budgetVariantUUID, budgetProgramCode, budgetSubprogramCode, form, versionId, reportYear, debugging, reportType) => {
            const url = this.prepareUrl(
                '/api/budget/staffing_table/report-v2/generate',
                [
                    ['version',           versionId],
                    ['region',            regionCode],
                    ['budget-variant',    budgetVariantUUID],
                    ['budget-program',    budgetProgramCode],
                    ['budget-subprogram', budgetSubprogramCode],
                    ['form',              form],
                    ['year',              reportYear],
                    ['debugging',         debugging],
                    ['report-type',       reportType],
                ],
            );

            this.request<Report2>(
                { url, method: 'POST' },
                (data) => {
                    this.$emit(events.formReportSaved, data);
                },
                () => (this.i18nDb.translateByKey('modules.budget.staffing-table.reports.*GenerationPane*.errors.cannot-generate-and-save-report')),
                () => {
                    this.formReportLoadingSync = false
                },
            );
        });
    }
}
